import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { getUserSelector } from '../../../../../redux/reducers/reducerSlices/UserReducer';
import { sagaActions } from '../../../../../sagas/sagaActions';
import { AppConstant } from '../../../../Assests/AppConstant';
import Header from '../../../Header/Header';
import Navigationbar from '../../../Navigationbar/Navigationbar';
import ExcelFileList from './Components/ExcelFileList';
import CustomButton from '../../../Common/CustomButton/CustomButton';
import Popup from '../../../Common/Popup/Popup';
import CustomFieldWithTtile from '../../../Common/CustomField/CustomFieldWithTtile';
import { ReactComponent as UploadPic } from "../../../../Assests/Svg/file-upload.svg";
import { getWarehouseDataReducer } from '../../../../../redux/reducers/reducerSlices/GetWarehouseDataReducer';
import { getFileUploadReducer } from '../../../../../redux/reducers/reducerSlices/FileuploadReducer';
import { showAlert } from '../../../../Assests/Utility';
import { toast } from 'react-toastify';
import { getExcelPoFileReducer } from '../../../../../redux/reducers/reducerSlices/ExcelPoFileReducer';
import _ from 'lodash'; 
import ExcelFileUploadStatusList from './Components/ExcelFileUploadStatusList';
import moment from 'moment-timezone';
import { getCommoditySelector } from '../../../../../redux/reducers/reducerSlices/CommodityReducer';

const DOLLAR_GENERAL="DOLLAR GENERAL"
const ALDI_ROYAL_PALM_BEACH = "ALDI - ROYAL PALM BEACH"

const ExcelLoads = (props) => {
  const { themeSelected } = props;
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [dockList, setDockList] = useState([]);

        const userPermission = useSelector(getUserSelector);
        const {selectedWarehouse} = userPermission;
  const [inputs, setInputs] = useState({
    warehouseId:"",
    dock: "",
    shift: "",
    commodity:"",
    scheduleDate:"",
    excelFile: "",
  });
  
  const [errors, setErrors] = useState({});
  const [dirty, setDirty] = useState({});
    const [fileUploading, setFileUploading] = useState({ loading: false, name: "" });
  const fileRef = useRef(null);
  const warehouseData = useSelector(getWarehouseDataReducer);
  const { commodityList , isLoading} = useSelector(getCommoditySelector);
  const fileUploadData = useSelector(getFileUploadReducer);
  const excelPoFileData = useSelector(getExcelPoFileReducer);
        const user = useSelector(getUserSelector);
            const { userType } = user
  const [warehouseList, setWarehouseList] = useState([]);
  const [showSessionData, setShowSessionData] = useState(false);
  const [selectedSessionId, setSelectedSessionId] = useState(null);
            
useEffect(() => {
  if (warehouseData.data && warehouseData.data.length > 0) {
    const uniqueData = _.uniqBy(warehouseData.data, 'ID');
    const orderedData = _.orderBy(uniqueData, ['WarehouseName'], ['asc']);
    setWarehouseList(orderedData);
  }
}, [warehouseData.data]);

useEffect(() => {
  if (userType !== AppConstant.userPermission.usertypes.superAdmin && userType!==AppConstant.userPermission.usertypes.administrator) {
    setInputs((prev) => ({
      ...prev,
      warehouseId: `${selectedWarehouse.ID},${selectedWarehouse.Name}`,
    }));
  }else{
     getWareHouseList();

  }

  return () => {
    dispatch({ type: sagaActions.RESET_EXCEL_PO_FILE });
  };
}, [userType,selectedWarehouse]);





useEffect(() => {
  if (excelPoFileData.success) {
    showAlert(toast.TYPE.SUCCESS, excelPoFileData.success.message);
    setInputs({});
    setDirty({});
    setErrors({});
    dispatch({ type: sagaActions.RESET_EXCEL_PO_FILE });
    getLogList();
  }
},[excelPoFileData.success])

useEffect(() => {
  if (excelPoFileData.error) {
    showAlert(toast.TYPE.ERROR, excelPoFileData.error.message || "Something went wrong");
    setInputs({});
    setDirty({});
    setErrors({});
    dispatch({ type: sagaActions.RESET_EXCEL_PO_FILE });
    getLogList();
  }
}, [excelPoFileData.error]);

const getSelectedWarehouseCommodityConfig = () => {
  if (!inputs.warehouseId) return null;
  const warehouseId = inputs.warehouseId.split(",")[0];
  const warehouse = warehouseList.find(w => String(w.ID) === String(warehouseId));
  return warehouse?.scheduleUploadsCommodityConfig ?? null;
};

useEffect(() => {
  if (inputs.warehouseId) {
    fetchDockList();
    if (getSelectedWarehouseCommodityConfig() === 'dropdown') {
      fetchCommodityByWarehouseId(inputs.warehouseId.split(",")[0]);
    }
  }
}, [inputs.warehouseId]);

  useEffect(() => {
    if (fileUploadData?.data) {
      setFileUploading({ loading: false, name: "" });
      if (fileUploadData.data.name) {
        setInputs({
          ...inputs,
          [fileUploadData.data.name]: fileUploadData?.data?.fileUrl,
        });
        dispatch({ type: sagaActions.RESET_FILE_UPLOAD });
      }
    } else {
      if (fileUploadData?.error) {
        setFileUploading({ loading: false, name: "" });
        showAlert(toast.TYPE.ERROR, fileUploadData.error.message);
      }
    }

  }, [fileUploadData]);

  const fetchCommodityByWarehouseId=(warehouseId)=>{
      dispatch({type: sagaActions.COMMODITY_LIST_BY_WAREHOUES_ID,payload:warehouseId})
  }

         const getLogList = ()=>{
                let payload = {
                  startDate: new Date(
                    new Date().setDate(new Date().getDate() - 30)
                  ).toISOString(),
                  endDate: new Date().toISOString(),
                  lastEvaluatedKey: null ,
                  limit: 10,
                  pageNo: 1,
                };
                if (userType !== AppConstant.userPermission.usertypes.superAdmin && userType !== AppConstant.userPermission.usertypes.administrator) {
                  payload.warehouseId = selectedWarehouse.ID;
                  
                }
                dispatch({
                  type: sagaActions.GET_EXCEL_PO_FILE_LIST,
                  payload: payload,
                });
              
          }


    const onFileChange = async (fileData, name) => {
      if(!inputs.warehouseId || !inputs.dock){
        showAlert(toast.TYPE.ERROR, "Please select Warehouse and Dock first.");
        return;
      }
      setFileUploading({ loading: true, name: name });
       const ext = fileData.name.split(".").pop(); // get extension
       const newFileName = `${inputs.warehouseId
         .split(",")[1]
         .replaceAll("-", " ")}-${
         inputs.dock.split(",")[1].replaceAll("-"," ")
       }-${Date.now()}.${ext}`;

       // Create new File with new name
       const renamedFile = new File([fileData], newFileName, {
         type: fileData.type,
       });

      const fd = new FormData();
      fd.append("file", renamedFile);
      fd.append("bucketName", process.env.REACT_APP_PO_EXCEL_UPLOAD_BUCKET);
      let fileUploadData = {
        name:name,
        fd,
      }
      dispatch({ type: sagaActions.FILE_UPLOAD_BY_BUCKET_NAME, payload: fileUploadData });
      fileRef.current.value = null;
    };


  const getWareHouseList = () => {
    dispatch({ type: sagaActions.GET_WAREHOUSE_LIST, payload: { "user_type": null, "cu_id": null, "company_id": null } });
  }

  useEffect(() => {
    if (warehouseData.dockListByWarehouseId && warehouseData.dockListByWarehouseId.length > 0) {
      setDockList(warehouseData.dockListByWarehouseId);
    }else{
      setDockList([]);
    }
  }, [warehouseData.dockListByWarehouseId]);

    const fetchDockList = () => {
      dispatch({ type: sagaActions.GET_DOCKLIST_BY_WAREHOUSE_ID, payload: { "warehouse_id": inputs.warehouseId.split(",")[0] } });
    };


        const createDockListDD = () => {
            return dockList.map((data, index) => {
                return (
                  <option key={Math.random()} value={`${data.dock_id},${data.dock_name}`}>
                    {data.dock_name}
                  </option>
                );
            })
        }

                const createCommodityListDD = () => {
            return commodityList?.map((data, index) => {
                return (
                  <option key={Math.random()} value={`${data.TextField}`}>
                    {data.TextField}
                  </option>
                );
            })
        }

                const createWarehouseListDD = () => {
                  return (
                    warehouseList && warehouseList.length && warehouseList.map((data, index) => {
                      return (
                        <option key={Math.random()} value={`${data.ID},${data.WarehouseName}`}>
                          {data.WarehouseName}
                        </option>
                      );
                    })
                  );
                };


          const cancelbtndata = {
              show: true,
              text: AppConstant.comments.cancelCommentButtonTitle,
          };
      
          const submitbtnData = {
              show: true,
              text: AppConstant.superUserAdmin.warehouseAdmin.createWarehouseForm
                  .saveButtonTitle,
          };



    const handleChange = (data, name) => {
        setInputs((prev) => ({
            ...prev,
            [name]: data,
        }));
        setDirty((prev) => ({
            ...prev,
            [name]: true,
        }));
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };


    const handleErrors = (error, name) => {
      if (name && error) {
        
        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
        setDirty((prev) => ({
            ...prev,
            [name]: true,   
        }));
      }
    };

    const handleSubmit = () => {
        let errorObj = {};
        let isValid = true;
        Object.keys(inputs).forEach((key) => {
            if (key === "warehouseId" && !inputs[key]) {
                errorObj[key] = "Warehouse is required";
                isValid = false;
            } else if (key === "dock" && !inputs[key]) {
                errorObj[key] = "Dock is required";
                isValid = false;
            } else if (key === "excelFile" && !inputs[key]) {
                errorObj[key] = "Excel file is required";
                isValid = false;
            } else if(getSelectedWarehouseCommodityConfig() === 'dropdown' && key==="commodity" && !inputs[key]){
              errorObj[key] = "Commodity is required";
                isValid = false;
            }
            else if(inputs.warehouseId.includes(DOLLAR_GENERAL) && key==="scheduleDate" && !inputs[key]){
              errorObj[key] = "Schedule Date file is required";
                isValid = false;
            }
             else {
                errorObj[key] = "";
            }
        }); 
        setErrors(errorObj);
        setDirty((prev) => ({
            ...prev,
            ...Object.keys(inputs).reduce((acc, key) => ({ ...acc, [key]: true }), {}),
        }));  
        
        if (isValid) {
          const fileData = inputs.excelFile;
          if (!fileData) {
            showAlert(toast.TYPE.ERROR, "Please upload an Excel file.");
            return;
          }
          const apiPayload = {
            warehouseId: inputs.warehouseId.split(",")[0],
            dockId: inputs.dock.split(",")[0],
            fileUrl: inputs.excelFile,
            commodity:inputs.commodity || "",
            scheduleDate:inputs.scheduleDate || ""
          };
          dispatch({ type: sagaActions.ADD_EXCEL_PO_FILE, payload: apiPayload });
          setShowModal(false);
          setInputs({});
          setDirty({});
          setErrors({});
        }
      }
    const createForm = () => {
        return (
          <div>
            {(userType === AppConstant.userPermission.usertypes.superAdmin || userType === AppConstant.userPermission.usertypes.administrator) && (
              <CustomFieldWithTtile
                type={"select"}
                showError={
                  dirty["warehouseId"] && errors["warehouseId"]
                    ? errors["warehouseId"]
                    : ""
                }
                name={"warehouseId"}
                value={inputs.warehouseId ? inputs.warehouseId : ""}
                handleErrors={handleErrors}
                title={"Warehouse"}
                required={true}
                onChange={(data, name) => handleChange(data, name)}
                listData={createWarehouseListDD}
              />
            )}
            <CustomFieldWithTtile
              type={"select"}
              showError={dirty["dock"] && errors["dock"] ? errors["dock"] : ""}
              name={"dock"}
              value={inputs.dock ? inputs.dock : ""}
              // handleErrors={handleErrors}
              title={"Dock"}
              required={true}
              onChange={(data, name) => handleChange(data, name)}
              listData={createDockListDD}
            />
            {inputs && inputs.warehouseId && getSelectedWarehouseCommodityConfig() === 'dropdown' ?
            <>
            <CustomFieldWithTtile
              type={"select"}
              showError={dirty["commodity"] && errors["commodity"] ? errors["commodity"] : ""}
              name={"commodity"}
              value={inputs.commodity ? inputs.commodity : ""}
              handleErrors={handleErrors}
              title={"Commodity"}
              required={true}
              onChange={(data, name) => handleChange(data, name)}
              listData={createCommodityListDD}
            />
            </>:""}
            {inputs && inputs.warehouseId && inputs.warehouseId.includes(DOLLAR_GENERAL)  ? 
            <>
            <div className="inputTitle">
              Schedule Date <span className="color-red">*</span>
            </div>
            <input
              type={"date"}
              name={"scheduleDate"}
              className='w-100 customTextInput'
              value={inputs.scheduleDate ? inputs.scheduleDate : ""}
              onBlur={handleErrors}
              title={"Schedule Date"}
              required={true}
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              min={moment().subtract(2, "days").format("YYYY-MM-DD")}
            />
             {errors && errors["scheduleDate"] && <span className="errorMessage">
                        {errors["scheduleDate"] ? errors["scheduleDate"] : ""}
                      </span>}
            </>
            :""}
            {/* <CustomFieldWithTtile
              type={"text"}
              showError={
                dirty["shift"] && errors["shift"] ? errors["shift"] : ""
              }
              name={"shift"}
              value={inputs.shift ? inputs.shift : ""}
              handleErrors={handleErrors}
              title={"Shift"}
              required={false}
              onChange={(data, name) => handleChange(data, name)}
            /> */}

            <div className="mt-2 f-14">
              <label className="form-label fw-bold">Upload Excel File</label>

              {/* Hidden file input */}
              <input
                ref={fileRef}
                type="file"
                id="excelFile"
                name="excelFile"
                accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                style={{ display: "none" }}
                onChange={(e) => onFileChange(e.target.files[0], "excelFile")}
              />

              {/* Custom upload button */}
              <label
                htmlFor="excelFile"
                className="d-flex align-items-center justify-content-center border rounded p-3 bg-light text-success"
                style={{ cursor: "pointer", minHeight: "120px" }}
              >
                <div className="text-center">
                  <UploadPic />
                  <div className="mt-2 fw-semibold">Click to Upload Excel</div>
                  <small className="text-muted">.xlsx files only</small>
                </div>
              </label>
              {fileUploading.loading && (
                <span
                  className="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              {dirty["excelFile"] && errors["excelFile"] && (
                <div className="text-danger">{errors["excelFile"]}</div>
              )}
            </div>
            {inputs.excelFile && !fileUploading.loading && (
              <div className="mt-2 f-16 d-flex align-items-center gap-3">
                <p>{decodeURIComponent(inputs.excelFile).split("/").pop()}</p>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => {
                    setInputs((prev) => ({
                      ...prev,
                      excelFile: "",
                    }));
                  }}
                >
                  Remove
                </button>
              </div>
            )}
            <div className="d-flex justify-content-end mt-3">
              <CustomButton
                className="btn btn-reschedule marrt-10"
                onClick={() => {
                  setShowModal(false);
                  setInputs({});
                  setDirty({});
                  setErrors({});
                }}
                title={cancelbtndata.text}
              />
              <CustomButton
                className={"btn btn-approve"}
                onClick={handleSubmit}
                title={submitbtnData.text}
              />
            </div>
          </div>
        );
    };


    const closepopup = () => {
        setShowModal(false);
          if (userType !== AppConstant.userPermission.usertypes.superAdmin && userType!==AppConstant.userPermission.usertypes.administrator) {
             setInputs({
              warehouseId: `${selectedWarehouse.ID},${selectedWarehouse.Name}`,
          });
          }else{
        setInputs({});
      }
        setDirty({});
        setErrors({});

    }

      const showUploadPopup = () => {
        const popupObj = {
          id: "showUploadPopup1",
          modalLabel: "showUploadPopup1",
          showClose: true,
          showfooter: false,
          showHeader: true,
          sendDriverNotification: false,
          modalSize: "lg",
          title: "Add Excel loads",
          bodyText: createForm(),
          subText: "",
          keyboard: false,
          backdrop: "static",
          footerBtn: {
            btn1: {
              show: true,
              text: AppConstant.comments.cancelCommentButtonTitle,
            },
            btn2: {
              show: true,
              text: AppConstant.superUserAdmin.warehouseAdmin
                .createWarehouseForm.saveButtonTitle,
            },
          },
        };

        return (
          <Popup
            {...popupObj}
            popupBtnHandler={(text) => () => ""}
            closepopup={closepopup}
            themeSelected={themeSelected}
            showModal={showModal}
          />
        );
      };

  return (
    <div className="container-fluid executor">
      <Header {...props} />
      <Navigationbar {...props} />

      {!showSessionData &&<div className="d-flex mt-2 justify-content-between align-items-center">
        <CustomButton
          className="addButton"
          onClick={() => {setShowModal(true)}}
          title="Upload Excel"
        />
              <CustomButton
          className="btn border-dark rounded-2 p-1 px-2 me-2"
          onClick={getLogList}
          title="Refresh"
        />
      </div>}
    {showSessionData ? <ExcelFileUploadStatusList themeSelected={themeSelected} sessionId={selectedSessionId} setShowSessionData={setShowSessionData}/> :
      <ExcelFileList setShowSessionData={setShowSessionData} setSelectedSessionId={setSelectedSessionId}/>}

      {showUploadPopup()}
    </div>
  );
};

export default ExcelLoads;